import { render, staticRenderFns } from "./WhyFooter.vue?vue&type=template&id=33bdb708&scoped=true"
import script from "./WhyFooter.vue?vue&type=script&lang=js"
export * from "./WhyFooter.vue?vue&type=script&lang=js"
import style0 from "./WhyFooter.vue?vue&type=style&index=0&id=33bdb708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bdb708",
  null
  
)

export default component.exports